/**
 * Converts a string into a URL-friendly slug by transforming it to lowercase, trimming whitespace,
 * replacing spaces and underscores with hyphens, and removing non-word characters.
 * @param {string} str - The string to slugify
 * @returns {string} The slugified string
 * @example slugify('Hello World') // 'hello-world'
 * @example slugify('Hello   World!') // 'hello-world'
 * @example slugify('Hello_World') // 'hello-world'
 * @example slugify('Hello-World') // 'hello-world'
 */
export const slugify = (str: string): string =>
  str
    .toLowerCase()
    .trim()
    .replace(/[\s_-]+/g, '-')
    .replace(/[^\w-]+/g, '');
